module.exports = __webpack_public_path__ + "img/share.f73f5e42.svg";